import type { PurchaseOrder } from "../../redistribution/models/PurchaseOrder.js";
import type { Sku } from "../../redistribution/models/Sku.ts";

/**
 * Pick a representative Sku record for display (prefer result, fall back to original)
 */
export function representativeSku(
  skuNumber: string,
  updatedPOs: PurchaseOrder[]
): Sku | undefined {
  let returnSku: Sku | undefined = undefined;
  for (const updatedPO of updatedPOs) {
    const s1 = updatedPO.skus.find((sk) => sk.skuNumber === skuNumber);
    returnSku =
      s1 && (!returnSku || s1.urgency > returnSku.urgency) ? s1 : returnSku;
  }
  return returnSku;
}

/**
 * Get quantity before redistribution for a specific SKU in a PO
 */
export function beforeQty(
  skuNumber: string,
  poNumber: string,
  originalPOs: PurchaseOrder[]
): number {
  const po = originalPOs.find((p) => p.purchaseOrderNumber === poNumber);
  if (!po) return 0;
  return po.skus.find((s) => s.skuNumber === skuNumber)?.lineItemQuantity ?? 0;
}

/**
 * Get quantity after redistribution for a specific SKU in a PO
 */
export function afterQty(
  skuNumber: string,
  poNumber: string,
  updatedPOs: PurchaseOrder[]
): number {
  const po = updatedPOs.find((p) => p.purchaseOrderNumber === poNumber);
  if (!po) return 0;
  return po.skus.find((s) => s.skuNumber === skuNumber)?.lineItemQuantity ?? 0;
}

export function skuOnPurchaseOrder(
  skuNumber: string,
  poNumber: string,
  purchaseOrders: PurchaseOrder[]
): Sku | undefined {
  const po = purchaseOrders.find((p) => p.purchaseOrderNumber === poNumber);
  return po?.skus.find((s) => s.skuNumber === skuNumber);
}
